export default __webpack_public_path__ + "app/components/tables/accounts/reactAccountsTable.html";